import { Firestore } from "../lib/firebase";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



toast.configure({
  autoClose: 2000,
  draggable: false
});
const MIND_CONDITION_TABLE_NAME = "mintConditions";

// export function deleteAllMintConditions(setData, setIsDeleting) {
//   setIsDeleting(true);

//   const batch = Firestore.batch();
//   const collectionRef = Firestore.collection(MIND_CONDITION_TABLE_NAME);

//   collectionRef
//     .get()
//     .then(querySnapshot => {
//       querySnapshot.forEach(doc => {
//         batch.delete(doc.ref);
//       });

//       return batch.commit();
//     })
//     .then(() => {
//       setData([]); // Clearing data since all documents are deleted
//       toast.success("All MintConditions deleted successfully!", {
//         position: toast.POSITION.TOP_LEFT
//       });
//     })
//     .catch(error => {
//       console.error("Error removing documents: ", error);
//     })
//     .finally(() => {
//       setIsDeleting(false);
//     });
// }

export function getMindCondition() {
  return Firestore.collection(MIND_CONDITION_TABLE_NAME)
    // .where("market", "==", country)
    .get()
    .then((results) => results.docs.map((garmentTypes) => garmentTypes.data()))
    .catch((error) => {
      throw new Error(error);
    });
}
export async function getMintConditionById(id) {
  try {
    return Firestore.collection(MIND_CONDITION_TABLE_NAME)
    .doc(id)
    .get()
    .then((docRef) => { return docRef.data() })
      .catch((error) => { 
        throw new Error(error);
    })
  
} catch (error) {
  throw error;
}
}

export function deleteMintConditionById(id, setData,isDeleting,setIsDeleting) {

  if (isDeleting) {
    return;
  }

  setIsDeleting(true);

  const docRef = Firestore.collection(MIND_CONDITION_TABLE_NAME).doc(id);

  docRef.delete()
    .then(() => {
      setData(prevData => prevData.filter(item => item.id !== id));
      toast.success("Mint Condition deleted successfully!", {
        position: toast.POSITION.TOP_LEFT
      });
    })
    .catch((error) => {
      console.error("Error removing document: ", error);
    })
    .finally(() => {
      setIsDeleting(false);
    });
}

export const create = async (payload, setData, inputText, setInputText, id, setIsLoading, isLoading) => {
  try {
    // Check if already loading or if an error has occurred
    if (isLoading) {
      return;
    }

    setIsLoading(true);

    // Check if the mint condition value already exists in Firestore
    const existingDoc = await Firestore.collection(MIND_CONDITION_TABLE_NAME)
      .where('value', '==', payload.value)
      .get()
      
      const loadingFunc = () => {
        setIsLoading(false)
      }
    if (!existingDoc.empty) {
      toast.error("Mint Condition already exists", {
        position: toast.POSITION.TOP_LEFT
      });
     
      setTimeout(loadingFunc, 2000);
      return;
    }

    await Firestore.collection(MIND_CONDITION_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        setData(prevData => [...prevData, { id: id, value: inputText, label: inputText }]);
        setInputText("");
        toast.success("Mint Condition created successfully!", {
          position: toast.POSITION.TOP_LEFT
          
        });
        setTimeout(loadingFunc, 2000);

      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};
export const update = async (payload,history) => {
  try {
    // Check if the garment value already exists in Firestore
    const existingDoc = await Firestore.collection(MIND_CONDITION_TABLE_NAME)
      .where('value', '==', payload.value)
      .get();

    if (!existingDoc.empty) {
      toast.error("Mint Condition already exists", {
        position: toast.POSITION.TOP_LEFT
      });
      return;
    }

    await Firestore.collection(MIND_CONDITION_TABLE_NAME)
      .doc(payload.id)
      .set(payload)
      .then(() => {
        history.goBack()
        toast.success("Mint Condition updated successfully!", {
          position: toast.POSITION.TOP_LEFT
        });
      });
  } catch (error) {
    toast.error(error.message, { position: toast.POSITION.TOP_LEFT });
  }
};

// export function getMindCondition() {
//   return Firestore.collection(MIND_CONDITION_TABLE_NAME)
//     // .where("market", "==", country)
//     .get()
//     .then((results) => results.docs.map((mindCondition) => mindCondition.data()))
//     .catch((error) => {
//       throw new Error(error);
//     });
// }

